export default "__VITE_ASSET__CCwBDQQq__"